var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "contact-offices grid grid-cols-1 lg:grid-cols-4 gap-16 lg:gap-32"
    },
    _vm._l(_vm.offices, function(office) {
      return _c(
        "div",
        {
          key: office.id,
          staticClass:
            "flex flex-col gap-8 pb-16 border-b border-gray-900 relative"
        },
        [
          _c(
            "a",
            {
              staticClass: "text-orange text-20 font-semi",
              attrs: { href: office.link }
            },
            [_vm._v(_vm._s(office.title.rendered))]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                staticClass: "block  font-regular",
                class: ["text-" + _vm.theme],
                attrs: { href: "mailto:" + office.acf.email }
              },
              [
                _c("span", { staticClass: "text-orange" }, [_vm._v("E:")]),
                _vm._v(" " + _vm._s(office.acf.email))
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "block font-regular group",
                class: ["text-" + _vm.theme],
                attrs: { href: "tel:" + office.acf.phone }
              },
              [
                _c("span", { staticClass: "text-orange" }, [_vm._v("T:")]),
                _vm._v(
                  "\n                " +
                    _vm._s(office.acf.phone) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass:
              "fas fa-chevron-right text-14 group-hover:mr-[-8px] transition-all absolute right-0 bottom-32 lg:bottom-16",
            class: ["text-" + _vm.theme]
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }